import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { DashboardGeralComponent } from './sessoes/dashboard-geral/dashboard-geral.component';
import { SharedModule } from '../shared/shared.module';
import { DashboardIndicadoresDiariosComponent } from './sessoes/dashboard-diario/dashboard-indicadores-diarios.component';
import { DashboardIndicadoresSemanaisComponent } from './sessoes/dashboard-semanal/dashboard-indicadores-semanais.component';
import { DashboardIndicadoresAnuaisComponent } from './sessoes/dashboard-anual/dashboard-indicadores-anuais.component';

@NgModule({
    declarations: [
            DashboardComponent,
            DashboardGeralComponent,
            DashboardIndicadoresDiariosComponent,
            DashboardIndicadoresSemanaisComponent,
            DashboardIndicadoresAnuaisComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        DashboardComponent
    ]
})
export class DashboardModule { }
